import { useTheme } from "@hooks";
import { constants } from "@layout";
import { CSSProperties } from "react";

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    container: {
      display: "flex",
      flexDirection: "column",
    },
    step: {
      display: "flex",
      height: 60,
    },
    stepInner: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
    stepIncomplete: {
      width: 16,
      height: 16,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    stepIncompleteInner: {
      width: 8,
      height: 8,
      backgroundColor: theme.step.incomplete,
      borderRadius: constants.radius.button,
    },
    line: {
      marginTop: 4,
      width: 1.5,
      height: 36,
    },
    activeLine: {
      backgroundColor: theme.step.complete,
    },
    inactiveLine: {
      backgroundColor: theme.step.incomplete,
    },
    content: {
      marginLeft: 16,
      marginTop: -2.5,
    },
    title: {
      fontSize: 14,
      fontWeight: 600,
    },
    subtitle: {
      fontSize: 12,
      color: theme.text.secondary,
    },
  };

  return styles;
};
